import React, { useCallback, useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Stack, styled, TextField, Typography } from '@mui/material'
import { AiOutlineSend, AiOutlineUser } from 'react-icons/ai'
import Captcha from '../../../component/Captcha'
import NPCForm from '../../../component/NPCForm'
import { AsideSize } from '../../../config'
import { useTranslation } from '../../../hooks/Localization'
import { Link as RouterLink } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../states/app/hooks'
import { LoginAsync, selectLogin as SelectUser, setToken } from '../../../states/features/User/LoginSlice'
import { setCaptchaCode } from '../../../states/features/Captcha/CaptchaSlice'
import { useHistory } from 'react-router-dom'
import { changeState, eventMessage, eventSeverity, eventShow } from '../../../states/features/Toast/ToastSlice'
import { blue } from '@mui/material/colors'
import { eventLoading } from '../../../states/features/Backdrop/BackdropSlice'
import useSetAsideMenu from '../../../hooks/useSetAsideMenu'

const StyledBox = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: ${({ theme }) => theme.spacing(4)};
`
const StyledForm = styled('form')`
    width: 50%;
    z-index: 1;
    ${({ theme }) => theme.breakpoints.down('lg')} {
        width: 100%;
    }
`
const StyledHeaderForm = styled(Typography)`
    justify-content: center;
    display: flex;
    align-items: center;
    font-weight: 300;
`
const StyledBoxLink = styled(Box)`
    display: -webkit-inline-box;
    justify-content: space-between;
`

const StyledBoxFooter = styled(Box)`
    text-align: right;
`
const StyledLinkRegister = styled(Typography)(`
    color: inherit;
    margin :0px 5px;
`) as typeof Typography

const Login: React.FC = () => {
    const t = useTranslation
    const dispatch = useAppDispatch()
    const { token, status, messages } = useAppSelector(SelectUser)
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [captcha, setCaptcha] = useState<number | string>('123')
    const history = useHistory()
    const errFillInput = t('The username or password is incorrect') as string
    const succesLogin = t('Login Sucess')
    useSetAsideMenu('Login')

    useEffect(() => {
        if (token) {
            history.push('/')
        }
    }, [token, history])

    const clearForm = useCallback(() => {
        setUsername('')
        setPassword('')
        setCaptcha('123')
    }, [])
    const handleSubmit = useCallback(
        (e: React.SyntheticEvent) => {
            e.preventDefault()
            dispatch(!username || !password || !captcha ? changeState({ show: true, message: errFillInput, severity: 'error' }) : LoginAsync({ username, password, captcha }))
        },
        [username, password, captcha, dispatch, errFillInput]
    )

    useEffect(() => {
        dispatch(eventLoading(status === 'loading'))
        if (status === 'failed' || status === 'succeeded') {
            dispatch(eventMessage(messages))
            dispatch(setCaptchaCode())
            dispatch(eventShow(true))
            dispatch(eventSeverity(status === 'failed' ? 'error' : 'success'))
        }
        if (status === 'succeeded') {
            dispatch(eventMessage(succesLogin))
            dispatch(setToken(localStorage.getItem('token')))
            clearForm()
        }
    }, [status, messages, dispatch, clearForm, token, succesLogin])

    return (
        <StyledBox>
            <NPCForm />
            <StyledForm onSubmit={(e) => handleSubmit(e)}>
                <Stack spacing={2}>
                    <Box textAlign="center">
                        <AiOutlineUser size={60} color={blue[900]} />
                    </Box>
                    <StyledHeaderForm variant="h4" color={blue[900]} sx={{ marginTop: '0px !important' }}>
                        {t('Login')}
                    </StyledHeaderForm>
                    <TextField required onChange={(e) => setUsername(e.target.value)} value={username} id="username" label="Số điện thoại" fullWidth variant="standard" autoComplete="off" type="text" />
                    <TextField required onChange={(e) => setPassword(e.target.value)} value={password} id="password" label={t('Password1')} fullWidth variant="standard" autoComplete="off" type="password" />
                    <Captcha>
                        <TextField required value={captcha} onChange={(e) => setCaptcha(e.target.value)} label={t('Captcha')} fullWidth variant="standard" type="text" />
                    </Captcha>
                    <StyledBoxLink>
                        {status !== 'loading' ? (
                            <Button type="submit" startIcon={<AiOutlineSend size={AsideSize.ICON} />} variant="contained" color="success">
                                {t('Submit')}
                            </Button>
                        ) : (
                            <Button type="button" disabled={true} startIcon={<CircularProgress color="success" size={AsideSize.ICON} />} variant="contained">
                                {t('Loading')} ...
                            </Button>
                        )}

                        <StyledBoxFooter>
                            <Typography variant="body2">
                                <StyledLinkRegister component={RouterLink} to="/quen-mat-khau.html" variant="body2">
                                    {t('Forgot Password')}?
                                </StyledLinkRegister>
                                <br />
                                <StyledLinkRegister component={RouterLink} to="/dang-ky-tai-khoan.html" variant="body2">
                                    {t("Don't have an account")}?
                                </StyledLinkRegister>
                            </Typography>
                        </StyledBoxFooter>
                    </StyledBoxLink>
                </Stack>
            </StyledForm>
        </StyledBox>
    )
}

export default Login
